<div class="wrapper">
  <canvas #PieChart></canvas>
</div>
